import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLoadingComponent } from './c-loading.component';



@NgModule({
  declarations: [CLoadingComponent],
  imports: [
    CommonModule
  ], exports : [CLoadingComponent]
})
export class CLoadingModule { }
